module.exports = __webpack_public_path__ + "img/background_c3-2-2_mobile.894827d3.jpg";